import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the archive api
 */
export class ArchiveService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getArchives(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/archives' + params);		
		return data;
	}

	exportArchives(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/archives/export' + params);
	}
	
	async getArchive(archiveId, companyId) {	
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}
		var result = await this.makeGETRequest('/api/resource/archives/' + archiveId + companyParam);
		return result;
	}	
	
	async getArchiveManifest(archiveId, companyId) {
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}		
		var result = await this.makeGETRequest('/api/resource/archives/' + archiveId + '/manifest' + companyParam);
		return result;
	}	

	async getArchiveMessage(archiveId, companyId) {	
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}		
		var result = await this.makeGETRequest('/api/resource/archives/' + archiveId + '/messages' + companyParam);
		return result;
	}	

	async createArchive(archiveRequest, companyId) {
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}			
		var saved = await this.makePOSTRequest('/api/resource/archives' + companyParam, archiveRequest);
		return saved;
	}
	
	async ftpImportArchive(ftpRequest, companyId) {
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}			
		var saved = await this.makePOSTRequest('/api/resource/archives'+ companyParam, ftpRequest );
		return saved;
	}
	
	async restoreArchive(archiveId, companyId, restoreRequest) {
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}		
		var saved = await this.makePUTRequest('/api/resource/archives/' + archiveId + companyParam, restoreRequest);
		return saved;
	}	
	
	downloadArchive(archiveId, companyId) {			
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}		
		this.downloadFile('/api/resource/archives/' + archiveId + '/download' + companyParam);		
	}	

	async deleteArchive(archiveId, companyId) {
		var companyParam = '';
		if (companyId) {
			companyParam = '?companyId=' + companyId;
		}		
		var result = await this.makeDELETERequest('/api/resource/archives/' + archiveId,  + companyParam);		
		return result;
	}	
	
};